/**
 * The scope of a POS menu sync, chosen by the user when they click Sync in Items & Mods.
 *
 * FULL imports the menu: it refreshes the POS cache, then creates menu items and modifiers for any POS
 * items that don't have one yet and links them to the company templates.
 *
 * AVAILABILITY is the lightweight sync: it refreshes the POS cache and updates pricing and availability
 * on existing items only. Nothing new is created.
 *
 * Mirrors the SyncMode union in @ready/menusync.
 */
enum MenuSyncMode {
  FULL = 'full',
  AVAILABILITY = 'availability',
}

export default MenuSyncMode;
